import axios from "../../../../../../api/axiosInstance";
import { FetchLedgerAccountsResponse } from "./types";

export const fetchLedgerAccounts = async (
  signal?: AbortSignal,
): Promise<FetchLedgerAccountsResponse> => {
  const response = await axios.get<FetchLedgerAccountsResponse>(
    "/api/private/ledger-accounts",
    { signal },
  );
  return response.data;
};
